// ** React Imports
import { useEffect, useState } from 'react'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'

// ** Third Party Components
import classnames from 'classnames'
import { IconSearch } from '@tabler/icons-react'
import * as TablerIcons from '@tabler/icons-react'
import { NavItem } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

// // ** Store & Actions
// import { useDispatch } from 'react-redux'
// import { handleSearchQuery } from '@store/actions/navbar'

// ** Custom Components
import Autocomplete from '@components/autocomplete'
import { appInsights } from '../../../../_services/AppInsights'
import { EventType } from '../../../../utility/types'
import styled from 'styled-components'
// import { useSelector } from 'react-redux'

const SearchInputWraper = styled(NavItem)`
  list-style: none;
  width: 100%;
`

const NavbarSearch = () => {
  // ** Store Vars
  // const dispatch = useDispatch()
  // const profile = useSelector((state) => state.profileReducer.profile)
  const navigate = useNavigate()

  // ** States
  const [suggestions] = useState([])
  const [navbarSearch, setNavbarSearch] = useState(false)
  const trackSearchHistory = useTrackEvent(appInsights, EventType.SearchHistory)

  // ** ComponentDidMount
  useEffect(() => {
    // axios.get('/api/main-search/data').then(({ data }) => {
    //   setSuggestions(data.searchArr)
    // })
  }, [])

  // ** Removes query in store
  const handleClearQueryInStore = () => null //dispatch(handleSearchQuery(''))

  // ** Function to handle external Input click
  const handleExternalClick = () => {
    // if (navbarSearch === true) {
    setNavbarSearch(false)
    handleClearQueryInStore()
    // }
  }

  // ** Function to clear input value
  const handleClearInput = (setUserInput) => {
    if (!navbarSearch) {
      setUserInput('')
      handleClearQueryInStore()
    }
  }

  // ** Function to redirect to search page and search by word
  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (e.target.value !== '') {
        trackSearchHistory({ searchTerm: e.target.value })
        setTimeout(() => {
          setNavbarSearch(false)
          navigate({
            pathname: '/search',
            search: `?search=${e.target.value}`
          })
        }, 1)
        e.target.blur()
      }
    }

    setNavbarSearch(true)
  }

  // ** Function to handle search suggestion Click
  const handleSuggestionItemClick = () => {
    setNavbarSearch(false)
    handleClearQueryInStore()
  }

  // ** Function to handle search list Click
  const handleListItemClick = (func, link, e) => {
    func(link, e)
    setTimeout(() => {
      setNavbarSearch(false)
    }, 1)
    handleClearQueryInStore()
  }

  return (
    <SearchInputWraper onClick={() => setNavbarSearch(true)}>
      {/* <NavLink className='nav-link-search'> */}
      {/* <IconSearch className="ficon" /> */}
      {/* </NavLink> */}
      <div>
        {/* <div className="search-input-icon">
          <IconSearch />
        </div> */}
        {/* {navbarSearch ? ( */}
        <Autocomplete
          className="form-control"
          suggestions={suggestions}
          filterKey="title"
          filterHeaderKey="groupTitle"
          grouped={true}
          placeholder={'Search for apps'}
          autoFocus={false}
          onSuggestionItemClick={handleSuggestionItemClick}
          externalClick={handleExternalClick}
          clearInput={(userInput, setUserInput) => handleClearInput(setUserInput)}
          onKeyDown={onKeyDown}
          icon={<IconSearch width={18} height={18} color="var(--text-heading)" />}
          // onChange={e => dispatch(handleSearchQuery(e.target.value))}
          customRender={(
            item,
            i,
            filteredData,
            activeSuggestion,
            onSuggestionItemClick,
            onSuggestionItemHover
          ) => {
            const IconTag = TablerIcons[item.icon ? item.icon : 'IconX']
            return (
              <li
                className={classnames('suggestion-item', {
                  active: filteredData.indexOf(item) === activeSuggestion
                })}
                key={i}
                onClick={(e) => handleListItemClick(onSuggestionItemClick, item.link, e)}
                onMouseEnter={() => onSuggestionItemHover(filteredData.indexOf(item))}>
                <div
                  className={classnames({
                    'd-flex justify-content-between align-items-center': item.file || item.img
                  })}>
                  <div className="item-container d-flex">
                    {item.icon ? (
                      <IconTag size={17} />
                    ) : item.file ? (
                      <img src={item.file} height="36" width="28" alt={item.title} />
                    ) : item.img ? (
                      <img
                        className="rounded-circle mt-25"
                        src={item.img}
                        height="28"
                        width="28"
                        alt={item.title}
                      />
                    ) : null}
                    <div className="item-info ml-1">
                      <p className="align-middle mb-0">{item.title}</p>
                      {item.by || item.email ? (
                        <small className="text-muted">
                          {item.by ? item.by : item.email ? item.email : null}
                        </small>
                      ) : null}
                    </div>
                  </div>
                  {item.size || item.date ? (
                    <div className="meta-container">
                      <small className="text-muted">
                        {item.size ? item.size : item.date ? item.date : null}
                      </small>
                    </div>
                  ) : null}
                </div>
              </li>
            )
          }}
        />
      </div>
    </SearchInputWraper>
  )
}

export default NavbarSearch
